import rt103765Raw from '../../../../assets/rt103765KayttoiatJaKunnossapito.json';
import rt103766Raw from '../../../../assets/rt103766TalotekniikkaKayttoiatJaKunnossapito.json';
import sahkoTietotekniikkaRaw from '../../../../assets/rt103766SahkoTietotekniikkaKayttoiat.json';
import { buildTree } from './rtSectionTree';

// Only hasOptions:true rows are real multiple-choice questions — the rest
// are single-value facts (e.g. a rakenneosa whose own row already carries
// its one RL value, no separate options listed) with nothing to choose
// between, so they're excluded from the interactive questionnaire tree.
function makeDataset(key, label, raw) {
  const questions = raw.filter(q => q.hasOptions);
  return {
    key,
    label,
    questions,
    tree: buildTree(questions),
    // Flat lookup by code, built from the FULL raw dataset (not just the
    // hasOptions:true ones) — kept for any future use that wants to resolve
    // a code regardless of whether it was an interactive question.
    questionsByCode: Object.fromEntries(raw.map(q => [q.code, q])),
  };
}

// Question codes are unique within a dataset and, as generated, never
// collide across datasets either (RT103765: short numeric like "1131";
// RT103766 Talotekniikka: dotted like "21.11.1.2"; Sähkö/Tietotekniikka:
// letter-prefixed like "S120"/"T810") — so every dataset shares one
// answers map per kiinteistö (see useRTKayttoikaVastaukset.js) with no
// namespacing needed, and an answer picked in one tab never collides with
// another tab's question.
export const KAYTTOIKA_DATASETS = [
  makeDataset('rakennustekniikka', 'Rakennustekniikka', rt103765Raw),
  makeDataset('talotekniikka', 'Talotekniikka', rt103766Raw),
  // Its own liite document ("Sähkö- ja tietoteknisten järjestelmien
  // elinkaari"), own numeric-code convention (S/T, not Talo 2000's
  // 1/11/113) and a simpler per-row shape (one elinkaari figure, no RL1-3
  // split, no separate tarkastus-/huoltoväli) — kept separate from
  // Talotekniikka rather than folded into it as a group, now that the
  // real source document confirms S and T are the document's own two
  // top-level sections, not a grouping this app invented.
  makeDataset('sahkoTietotekniikka', 'Sähkö- ja tietotekniikka', sahkoTietotekniikkaRaw),
];
